"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var app_1 = require("../app");
var localization_1 = require("../localization");
var error_message_1 = __importDefault(require("../components/error_message"));
var find_1 = __importDefault(require("lodash/find"));
var address_display_1 = __importDefault(require("../components/address_display"));
var classnames_1 = __importDefault(require("classnames"));
var useContext = react_1.default.useContext, useRef = react_1.default.useRef;
exports.default = (function (props) {
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var country = context.country, billingAddress = context.billingAddress;
    var _a = props.newBillingForm, register = _a.register, errors = _a.errors, watch = _a.watch;
    var supportedCountries = Object.keys(localization_1.LocaleConfig).map(function (key) {
        return { abbreviation: key, name: localization_1.LocaleConfig[key].countryName };
    });
    var firstNameRef = useRef();
    var _b = __read((0, react_1.useState)(billingAddress ? billingAddress.country : country), 2), selectedBillingCountry = _b[0], setBillingCountry = _b[1];
    var lc = (0, find_1.default)(localization_1.LocaleConfig, function (v) { return v.countryName === selectedBillingCountry; }) || localization_1.LocaleConfig.US;
    var config = localization_1.LocaleConfig[lc.code];
    var newBillingAddress = props.newBillingAddress, setNewBillingAddress = props.setNewBillingAddress;
    var formValues = watch();
    var fieldContainerClassName = function (key) {
        return (0, classnames_1.default)({ 'form-input': true, 'with-error': errors[key], 'is-filled': !!formValues[key] });
    };
    var useNewBillingAddress = function () {
        setNewBillingAddress(true);
        setTimeout(function () {
            if (firstNameRef.current)
                firstNameRef.current.focus();
        }, 100);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h4", { className: 'h4 margin-bottom-2 margin-top-6' }, "Billing Address"),
        react_1.default.createElement("p", { className: 'font-lighter text-brown-grey margin-bottom-6', style: { fontSize: '14px' } }, "Select the address that matches your card or payment method."),
        react_1.default.createElement("div", { className: 'checkout-delivery-methods-container' },
            billingAddress && (react_1.default.createElement("div", { className: 'checkout-shipping-method grid-x', key: 'existing' },
                react_1.default.createElement("div", { className: 'cell small-1' },
                    react_1.default.createElement("input", { type: 'radio', checked: !newBillingAddress, onChange: function () { return setNewBillingAddress(false); } })),
                react_1.default.createElement("div", { className: 'cell small-11 font-lighter padding-right-1  padding-left-2', style: { fontSize: '14px' } },
                    react_1.default.createElement(address_display_1.default, { address: billingAddress, showCountry: true })))),
            react_1.default.createElement("div", { className: 'checkout-shipping-method', key: 'new' },
                react_1.default.createElement("div", { className: ' grid-x' },
                    react_1.default.createElement("div", { className: 'cell small-1' },
                        react_1.default.createElement("input", { type: 'radio', checked: newBillingAddress, onChange: function () { return useNewBillingAddress(); } })),
                    react_1.default.createElement("div", { className: 'cell small-11 font-lighter padding-right-1  padding-left-2' },
                        react_1.default.createElement("div", { style: { fontSize: '14px' } }, "Use a different billing address"))),
                newBillingAddress && (react_1.default.createElement("div", { className: 'margin-top-2' },
                    react_1.default.createElement("form", null,
                        react_1.default.createElement("div", { className: fieldContainerClassName('firstName') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'firstName', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'Email', ref: function (e) {
                                        register(e, { required: 'Required' });
                                        if (e)
                                            firstNameRef.current = e;
                                    } }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "First Name")),
                            react_1.default.createElement(error_message_1.default, { error: errors.firstName })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('lastName') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'lastName', autoComplete: 'family-name', type: 'text', ref: register({
                                        required: 'Required',
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Last Name")),
                            react_1.default.createElement(error_message_1.default, { error: errors.lastName })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('company') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'company', autoComplete: 'company', type: 'text', ref: register({}) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Company (Optional)"))),
                        react_1.default.createElement("div", { className: fieldContainerClassName('address1') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'address1', autoComplete: 'address-line-1', type: 'text', ref: register({ required: 'Required' }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Street Address"))),
                        react_1.default.createElement("div", { className: fieldContainerClassName('address2') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'address2', autoComplete: 'address-line2', type: 'text', ref: register({}) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Suite / Apartment #")),
                            react_1.default.createElement(error_message_1.default, { error: errors.address2 })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('city') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'city', type: 'text', autoComplete: 'shipping locality', ref: register({
                                        required: 'Required',
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "City")),
                            react_1.default.createElement(error_message_1.default, { error: errors.city })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('country') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("select", { name: 'country', autoComplete: 'shipping country', ref: register({
                                        required: 'Required',
                                    }), onChange: function (e) { return setBillingCountry(e.target.value); } }, supportedCountries.map(function (ctry) { return (react_1.default.createElement("option", { key: ctry.abbreviation }, ctry.name)); })),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Country")),
                            react_1.default.createElement(error_message_1.default, { error: errors.country })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('state') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("select", { name: 'state', autoComplete: 'shipping region', ref: register({
                                        required: 'Required',
                                    }) },
                                    react_1.default.createElement("option", null, "Select"),
                                    config.states.map(function (state) { return (react_1.default.createElement("option", { key: state.name, value: state.name }, state.name)); })),
                                react_1.default.createElement("span", { className: 'placeholder' }, config.labels.state)),
                            react_1.default.createElement(error_message_1.default, { error: errors.state })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('zip') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'zip', type: 'text', autoComplete: 'shipping postal-code', ref: register({
                                        required: 'Required',
                                        pattern: {
                                            value: config.zipValidationRegex,
                                            message: "Invalid ".concat(config.labels.zip, " format"),
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, config.labels.zip)),
                            react_1.default.createElement(error_message_1.default, { error: errors.zip })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('phoneNumber') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'phoneNumber', type: 'tel', autoComplete: 'tel', ref: register({
                                        required: 'Required',
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Phone Number")),
                            react_1.default.createElement(error_message_1.default, { error: errors.phoneNumber })))))))));
});
